<template>
   
<vs-popup class="holamundo main-popup cls-btn" title="Recover Profile" v-if="showRevertPopup" :active.sync="showRevertPopup">
     <i class="manual_close" @click="cancelClicked()"></i>
    <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <p>Are you sure to continue? </p>
            </div>      
          </div>
        </div>
        <div class="popup-footer relative">
          <vs-button color="dark" class="cancel" type="filled" @click="cancelClicked()">Cancel</vs-button>
          <vs-button color="success" class="save" @click="revertAccount()">Submit</vs-button>
        </div>
      </form>
    </vs-popup>
   
</template>
<script>
 import _ from "lodash";


  export default {
    components: {
      
    },

    data: () => ({
      userId:null,
      showRevertPopup:true
      }),
    watch: {
      

    },
    props: {
        isPetitioner: {
      type: Boolean,
      default: false
    },
        userData: {
      type: Object,
      default: null
    },//isPetitioner
    // showRevertPopup: {
    //   type: Boolean,
    //   default: false
    // } this.getPetitioners(true);
  },
    methods: {
      cancelClicked(success = false) {
       // this.showRevertPopup=false
        this.$emit('handleCloseRevertPopup', success);
        this.showRevertPopup=false
    },
    revertAccount() {
        let payLoad={
            "userId":this.userId 
        }
        this.$store.dispatch("revertMyAccount",payLoad).then((response) => {
          if (response.status === "Success") {
            this.$emit('handleCloseRevertPopup', true);
            this.showRevertPopup=false
            this.showToster({ message: response.message, isError: false });
            //this.cancelClicked(true)
            // this.$emit('handleCloseRevertPopup');
            // this.$emit('revert-success');
          } else {
            this.showToster({ message: response.message, isError: true });
          }
        }).catch((error) => {
          this.showToster({ message: error.message, isError: true });
        })
    },
    },
    mounted() {
    if(!this.isPetitioner&&this.checkProperty(this.userData,'_id')){
       this.userId = this.userData._id;
    }
    if(this.isPetitioner&&this.checkProperty(this.userData,'petitionerUserDetails',"_id")){
       this.userId = this.userData.petitionerUserDetails._id;
    }
    },
    computed:{
    
      
  }
  };
</script>